import React, { useState } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { useTranslation } from 'react-i18next'

import Tabs from '../../tabs'
import BookReviews from './book-reviews'
import { Book, BookWithRating } from '../../../../data/book/data-types'

type DescriptionProps = {
    book?: Book | BookWithRating
}

const Description: React.FunctionComponent<DescriptionProps> = ({ book }) => {
    const { t } = useTranslation('book')

    const [full, setFull] = useState(false)
    const [activeTab, changeTab] = useState("description")

    if (book == null) {
        return null
    }

    const [needsShortening, displaySynopsys] = shortenSynopsys(book?.synopsys!, full)

    return (
        <Container>
            <Tabs
                value={activeTab}
                captions={[
                    { title: t("description"), value: "description" },
                    { title: t("reviews"), value: "reviews" },
                ]}
                onChange={changeTab}

             />
            <Body> 
                {
                    activeTab === "description" &&
                    <>
                        { displaySynopsys }
                        { needsShortening && <Switcher onClick={() => setFull(!full)}> { full ? t('read_less') : t('read_more') } </Switcher> }
                    </>
                }
                {
                    activeTab === 'reviews' && 
                    <BookReviews book={book}/>
                }
            </Body>
        </Container>
    )
}

const synopsysLength = 1000

export const shortenSynopsys = (synopsys: string | null | undefined, isFull: boolean) => {
    synopsys = synopsys || ""
    const isShortened = synopsys.length > synopsysLength

    if (isFull) {
        return [isShortened, synopsys]
    }

    return [isShortened, isShortened ? synopsys.slice(0, synopsysLength) + '...' : synopsys]
}


const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    margin: 0 -16px 0 -16px;
    padding: 24px 16px;

    width: 100%;
    height: 100%;

    background: ${p => p.theme.colors.bg};
    border-radius: 10px;

    ${up('tablet')} {
        margin: 0;
        padding: 10px 48px 40px 48px;
    }
`


const Body = styled.div`
    width: 100%;

    font-size: 14px;
    line-height: 24px;

    margin-top: 24px;

    ${up('tablet')} {
        margin-top: 40px;
    }
`

const Switcher = styled.button`
    padding: 0;

    margin-left: 10px;

    font-size: 14px;
    line-height: 24px;
    color: ${p => p.theme.colors.accent};

    border: none;
    background: none;

    cursor: pointer;
`

export default Description